import httpService from './http.service';

const fetchParkingActive = (parkingPlaceId, query, state, mbsSuccess, dateFrom, dateTo) => httpService
    .get('/parkingActive?'+getParams(parkingPlaceId, query, state, mbsSuccess, dateFrom, dateTo))
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const getParams = (parkingPlaceId, query, state, mbsSuccess, dateFrom, dateTo) => {
    let result = parkingPlaceId ? 'parkingPlaceId='+parkingPlaceId:'';
    result = result + (query?(result?'&':'')+'query='+query:'');
    result = result + (state?(result?'&':'')+'state='+state:'');
    result = result + (mbsSuccess?(result?'&':'')+'mbsSuccess='+mbsSuccess:'');
    result = result + (dateFrom?(result?'&':'')+'dateFrom='+new Date(dateFrom).toISOString():'');
    result = result + (dateTo?(result?'&':'')+'dateTo='+new Date(dateTo).toISOString():'');
    return result;
}

export default {
    fetchParkingActive
};